/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Six_Digit_CodeInputs */

const th_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รหัส 6 หลัก`)
};

const en_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-digit code`)
};

const ja_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6桁の認証コード`)
};

const zh_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 位验证码`)
};

const es_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de 6 dígitos`)
};

const pt_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de 6 dígitos`)
};

const id_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode 6 digit`)
};

const fr_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code à 6 chiffres`)
};

const tl_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-digit na code`)
};

const vi_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã 6 chữ số`)
};

const ko_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6자리 코드`)
};

const de_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6-stelliger Code`)
};

const ru_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код из 6 цифр`)
};

const tr_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 haneli kod`)
};

const it_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice a 6 cifre`)
};

const pl_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod 6-cyfrowy`)
};

const uk_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код із 6 цифр`)
};

const hi_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 अंकों का कोड`)
};

const ar_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رمز من 6 أرقام`)
};

const ms_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod 6 digit`)
};

const bn_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`৬ অঙ্কের কোড`)
};

const zh_tw2_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 位數驗證碼`)
};

const zh_hk2_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 位數驗證碼`)
};

const ur_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6 ہندسوں کا کوڈ`)
};

const fa_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کد ۶ رقمی`)
};

const sw_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimbo wa tarakimu 6`)
};

const nl_six_digit_code = /** @type {(inputs: Six_Digit_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code van 6 cijfers`)
};

/**
* | output |
* | --- |
* | "6-digit code" |
*
* @param {Six_Digit_CodeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const six_digit_code = /** @type {((inputs?: Six_Digit_CodeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Six_Digit_CodeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_six_digit_code(inputs)
	if (locale === "ja") return ja_six_digit_code(inputs)
	if (locale === "zh") return zh_six_digit_code(inputs)
	if (locale === "es") return es_six_digit_code(inputs)
	if (locale === "pt") return pt_six_digit_code(inputs)
	if (locale === "id") return id_six_digit_code(inputs)
	if (locale === "fr") return fr_six_digit_code(inputs)
	if (locale === "tl") return tl_six_digit_code(inputs)
	if (locale === "vi") return vi_six_digit_code(inputs)
	if (locale === "ko") return ko_six_digit_code(inputs)
	if (locale === "de") return de_six_digit_code(inputs)
	if (locale === "ru") return ru_six_digit_code(inputs)
	if (locale === "tr") return tr_six_digit_code(inputs)
	if (locale === "it") return it_six_digit_code(inputs)
	if (locale === "pl") return pl_six_digit_code(inputs)
	if (locale === "uk") return uk_six_digit_code(inputs)
	if (locale === "hi") return hi_six_digit_code(inputs)
	if (locale === "ar") return ar_six_digit_code(inputs)
	if (locale === "ms") return ms_six_digit_code(inputs)
	if (locale === "bn") return bn_six_digit_code(inputs)
	if (locale === "zh-TW") return zh_tw2_six_digit_code(inputs)
	if (locale === "zh-HK") return zh_hk2_six_digit_code(inputs)
	if (locale === "ur") return ur_six_digit_code(inputs)
	if (locale === "fa") return fa_six_digit_code(inputs)
	if (locale === "sw") return sw_six_digit_code(inputs)
	if (locale === "nl") return nl_six_digit_code(inputs)
	return en_six_digit_code(inputs)
});